// GrowthBook flags forced on or off from the developer menu, in this browser
// only. initGrowthbook hands them to the SDK while the menu is on
// (isDevMenuEnabled); once it is off they are forgotten.
const STORAGE_KEY = 'lb-dev-menu-feature-overrides';

export function readFeatureOverrides() {
  try {
    const overrides = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return overrides && typeof overrides === 'object' ? overrides : {};
  } catch {
    return {};
  }
}

function writeFeatureOverrides(overrides) {
  try {
    if (Object.keys(overrides).length) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(overrides));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Storage blocked: the override is not kept.
  }
}

// value: true/false forces the flag, null goes back to GrowthBook's value.
export function setFeatureOverride(key, value) {
  const overrides = readFeatureOverrides();
  if (value === null || value === undefined) {
    delete overrides[key];
  } else {
    overrides[key] = value;
  }
  writeFeatureOverrides(overrides);
}

export function clearFeatureOverrides() {
  writeFeatureOverrides({});
}

export function applyFeatureOverrides(growthbook, devMenuEnabled) {
  if (!devMenuEnabled) {
    clearFeatureOverrides();
    return;
  }

  const overrides = readFeatureOverrides();
  if (growthbook && Object.keys(overrides).length) {
    growthbook.setForcedFeatures(new Map(Object.entries(overrides)));
  }
}
